/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for TimesheetType controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetTimesheetTypeByIdResponse, UpdateTimesheetTypeRequest, GetTimesheetTypesResponse, CreateTimesheetTypeRequest, CreateTimesheetTypeResponse, GetTimesheetTypeSelectResponse } from "../models";

@Injectable({ providedIn: "root" })
export class TimesheetTypeService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getTimesheetTypeById(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetTimesheetTypeByIdResponse>;
    getTimesheetTypeById(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetTimesheetTypeByIdResponse>>;
    getTimesheetTypeById(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetTimesheetTypeByIdResponse>>;
    getTimesheetTypeById(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/TimesheetType/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    updateTimesheetType(id: number, updateTimesheetTypeRequest: UpdateTimesheetTypeRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateTimesheetType(id: number, updateTimesheetTypeRequest: UpdateTimesheetTypeRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateTimesheetType(id: number, updateTimesheetTypeRequest: UpdateTimesheetTypeRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateTimesheetType(id: number, updateTimesheetTypeRequest: UpdateTimesheetTypeRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/TimesheetType/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updateTimesheetTypeRequest, requestOptions);
    }

    deleteTimesheetType(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteTimesheetType(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteTimesheetType(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteTimesheetType(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/TimesheetType/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    getTimesheetTypes(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetTimesheetTypesResponse>;
    getTimesheetTypes(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetTimesheetTypesResponse>>;
    getTimesheetTypes(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetTimesheetTypesResponse>>;
    getTimesheetTypes(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/TimesheetType`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createTimesheetType(createTimesheetTypeRequest: CreateTimesheetTypeRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreateTimesheetTypeResponse>;
    createTimesheetType(createTimesheetTypeRequest: CreateTimesheetTypeRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreateTimesheetTypeResponse>>;
    createTimesheetType(createTimesheetTypeRequest: CreateTimesheetTypeRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreateTimesheetTypeResponse>>;
    createTimesheetType(createTimesheetTypeRequest: CreateTimesheetTypeRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/TimesheetType`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, createTimesheetTypeRequest, requestOptions);
    }

    getTimesheetTypeSelect(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetTimesheetTypeSelectResponse>;
    getTimesheetTypeSelect(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetTimesheetTypeSelectResponse>>;
    getTimesheetTypeSelect(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetTimesheetTypeSelectResponse>>;
    getTimesheetTypeSelect(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/TimesheetType/Select`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }
}
